import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    root: {
      overflow: 'hidden',
      width: '100%',
      borderRadius: CornerRadius.r8,
      '& img': {
        width: '100%',
        borderRadius: CornerRadius.r8,
      },
    },
  },
  { name: 'template-item' },
);

export default useStyles;
